import React, { createContext } from "react"
import io from "socket.io-client"

const socket = io(process.env.REACT_APP_ADMIN_NOTIFICATION, {
  withCredentials: true,
  transports: ["websocket", "polling"],
})

export const SocketContext = createContext()

export const SocketProvider = ({ children }) => {
  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  )
}